const days = require('../constants/days')

/**
 * Return an array of day numbers in order from today
 * @param {boolean} [inclusive=false] - Include today
 * @example
 * // Assuming today is Monday
 * getDaysRangeFromToday()
 * // returns [2, 3, 4, 5, 6, 0]
 * getDaysRangeFromToday(true)
 * // returns [1, 2, 3, 4, 5, 6, 0]
 * @returns {number[]}
 */
const getDaysRangeFromToday = (inclusive = false) => {
  const todayDay = new Date().getDay()
  const initialOrder = Array.from({ length: days.length }).map((_, i) => i)
  return [
    ...initialOrder.slice(inclusive ? todayDay : todayDay + 1),
    ...initialOrder.slice(0, todayDay),
  ]
}

module.exports = getDaysRangeFromToday
